<section class="content-panel-b container-fluid">
  <div class="content-full">
    <div style="width: 100%;" [ngClass]="{'resume-sticky': screenSize > 939}">
      <mat-card class="configuration-card"
        [ngClass]=" ((disable || !deadlineSelect) && !resultOfRequestNotSuccess()) || loadingServicesPlus ? 'disabled-panel' : ''">
        <div class="sticky-mobile">

          <app-resume-quoter textHeader="Resumen" [showTitle]="true" [brand]="car.brand" [subBrand]="car.subBrand"
            [version]="car.version" [year]="car.year" [priceWithIva]="car.priceWithIva"
            [stateName]="stateSelected?.stateName" [ri]="checkRi()"
            [concept]="deadlineSelect?.concept === 'afin' || deadlineSelect?.concept === 'rr' ? 'Rent2Buy' : deadlineSelect?.concept"
            [period]="deadlineSelect?.period" [initialPayment]="deadlineSelect?.initialPayment"
            [monthlyPayment]="deadlineSelect?.monthlyPayment" [isMaxAdvancedRent]="isMaxAdvancedRent"
            [insurance]="insuranceSelected.insurance?.key" [purchaseValue]="checkPurchaseValue()"
            [isMaxPurchaseValue]="isMaxPurchaseValue" [appliedCode]="codeStatus === 'valid'"
            [isDropDown]="screenSize < 768"></app-resume-quoter>


          <div class="container-btn-file-b">
            <app-pdf-ford *ngIf="deadlineSelect" [dataQuoter]="dataQuoter" [car]="car" [deadlineSelect]="deadlineSelect"
              [stateSelected]="stateSelected" [insuranceSelected]="insuranceSelected"
              [allDeadlineSelect]="allDeadlineSelect" [registrationState]="registrationState" [ruleFifteen]="ruleFifteen"></app-pdf-ford>
          </div>
        </div>

        <mat-card-content class="content-config scroll-gray">
          <h3>¿Dónde te encuentras?</h3>
          <mat-form-field class="select-config" appearance="fill" *ngIf="states.length !== 0">
            <mat-select placeholder="Selecciona la entidad en que radicas" [(value)]="defaultState" disableRipple
              disableOptionCentering (selectionChange)="stateSelect($event.value, false); interactionUser()">
              <mat-option class="select-options" *ngFor="let state of states" [value]="state">{{state.stateName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <h3>¿Dónde emplacarías?</h3>
          <mat-form-field class="select-config" appearance="fill" *ngIf="registrationStates.length !== 0">
            <mat-select placeholder="Selecciona la entidad de emplacamiento" [(value)]="registrationState" disableRipple
              disableOptionCentering (selectionChange)="registrationStateSelect($event.value)">
              <mat-option *ngFor="let state of registrationStates" [value]="state">
                {{ state }}
              </mat-option>
              <mat-option *ngIf="stateSelected?.stateName && !registrationStates.includes(stateSelected.stateName)"
                [value]="stateSelected.stateName">
                {{ stateSelected.stateName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <hr>

          <ng-container>

            <h3>Pago inicial</h3>
            <span class="color-gray">Te ayudará a disminuir tu pago mensual</span>
            <div class="content-slider slider-configuration">
              <ngx-slider class="slider" [value]="valueRi" [options]="optionsFord"
                (userChangeEnd)="rentChange($event);"></ngx-slider>
                <span class="slider-input">$ <input type="number" class="form-control" min="0" [max]="rentPriceCeil" step="1000"
                  (input)="validateRangeInputMax($event)" [(ngModel)]="valueRi" [ngModelOptions]="{standalone: true}"
                  (change)="changeInputRi($event);" [disabled]="true"></span>
                </div>
          </ng-container>

          <hr>

          <h3>Selecciona la primera opción de color tu vehículo </h3>
          <mat-form-field class="select-config" appearance="fill" *ngIf="states.length !== 0">
            <mat-select placeholder="Selecciona un color" [(value)]="selectedColorA"
              (selectionChange)="updateAvailableColors()" disableRipple disableOptionCentering>

              <mat-option *ngFor="let color of availableColorsA" [value]="color">
                {{ color }}
              </mat-option>

            </mat-select>
          </mat-form-field>
          <h3>Selecciona la segunda opción de color de tu vehículo </h3>
          <mat-form-field class="select-config" appearance="fill" *ngIf="states.length !== 0">
            <mat-select placeholder="Selecciona un color" [(value)]="selectedColorB"
              (selectionChange)="updateAvailableColors()" disableRipple disableOptionCentering>

              <mat-option *ngFor="let color of availableColorsB" [value]="color">
                {{ color }}
              </mat-option>

            </mat-select>
          </mat-form-field>
          <h3>Selecciona la tercera opción de color de tu vehículo </h3>
          <mat-form-field class="select-config" appearance="fill" *ngIf="states.length !== 0">
            <mat-select placeholder="Selecciona un color" [(value)]="selectedColorC"
              (selectionChange)="updateAvailableColors()" disableRipple disableOptionCentering>

              <mat-option *ngFor="let color of availableColorsC" [value]="color">
                {{ color }}
              </mat-option>

            </mat-select>
          </mat-form-field>

          <div class="container-btn-autorize">
            <button (click)="preauthorize()" [disabled]="resultOfRequestNotSuccess() || !deadlineSelect"
              mat-raised-button id="boton-autorizar-plan{{isAfin ? '-rent2buy' : ''}}">¡QUIERO AUTORIZAR MI
              PLAN!</button>
          </div>

          <app-share-link [pageUrl]="'/cotizador/' + slashedUrl + '?quote='" [isPanelConfig]="true"
            [dataQuoter]="dataQuoter" [deadlineSelect]="deadlineSelect"
            carTitle="¡He visto este {{car.brand}} {{car.subBrand}} en" [metaUrl]="metaUrl"></app-share-link>

        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="loading-calculate" *ngIf="(disable || !deadlineSelect) && !resultOfRequestNotSuccess()">
    <app-loading-spinner diameter="110px" title="Por favor espera estamos cargando los plazos..."></app-loading-spinner>
  </div>
  <div class="loading-calculate"
    *ngIf="(!disable || deadlineSelect) && !resultOfRequestNotSuccess() && loadingServicesPlus">
    <app-loading-spinner diameter="110px" title="Por favor espera estamos cargando los plazos..."></app-loading-spinner>
  </div>

</section>